'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createSvg = require('./utils/createSvg');

var _createSvg2 = _interopRequireDefault(_createSvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createSvg2.default)(_react2.default.createElement(
  'g',
  null,
  _react2.default.createElement('circle', { fill: '#010101', cx: '12', cy: '12', r: '8' })
), 'FiberManualRecord');


//////////////////
// WEBPACK FOOTER
// ./~/material-react-icons/FiberManualRecord.js
// module id = 357
// module chunks = 0